import { COMPLETE_ONBOARDING, OnboardingActionTypes, PAYMENT_IDENTIFIER } from './types';

export function setOnboardingToComplete(onboardingCompleted: boolean): OnboardingActionTypes {
    return {
        type: COMPLETE_ONBOARDING,
        payload: onboardingCompleted,
    };
}

export function setPaymentIdentifier(value: string): OnboardingActionTypes {
    return {
        type: PAYMENT_IDENTIFIER,
        payload: value,
    };
}
